// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UpdateCommentTTRequestModel from '../../model/update-comment-tt-request-model';
import UpdateCommentTTRequestDTO from '../dto/update-comment-tt-request-dto';
import dtoSchema from '../schemas/update-comment-tt-request-schema';

export default abstract class UpdateCommentTTRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UpdateCommentTTRequestDTO>) {
    super();
    if (data) {
      this.ids = data.ids;
      this.commentTT = data.commentTT;
    }
  }
  /**
  */
  ids?: number[];
  /**
  */
  commentTT?: string;

  static toModel(dto: DeepPartial<UpdateCommentTTRequestDTO>): UpdateCommentTTRequestModel;
  static toModel(dto: DeepPartial<UpdateCommentTTRequestDTO> | undefined | null): UpdateCommentTTRequestModel | undefined;
  static toModel(dto: DeepPartial<UpdateCommentTTRequestDTO> | undefined | null): UpdateCommentTTRequestModel | undefined {
    return dto ? new UpdateCommentTTRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UpdateCommentTTRequestModel> | UpdateCommentTTRequestModel): UpdateCommentTTRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      ids: unwrapped.ids,
      commentTT: unwrapped.commentTT,
    } as UpdateCommentTTRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UpdateCommentTTRequestModel, can not map to UpdateCommentTTRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
